import {
  GET_FEEDBACK,
  GET_USER_FEEDBACK,
  ADD_FEEDBACK,
  UPDATE_FEEDBACK,
  DELETE_FEEDBACK,
  ARCHIVE_FEEDBACK,
  FEEDBACK_ERROR,
  SET_LOADING,
  CLEAR_ERRORS,
  CLEAR_FEEDBACK
} from '../types';

const feedbackReducer = (state, action) => {
  switch (action.type) {
    case GET_FEEDBACK:
      return {
        ...state,
        feedback: action.payload,
        loading: false
      };
    case GET_USER_FEEDBACK:
      return {
        ...state,
        userFeedback: action.payload,
        loading: false
      };
    case ADD_FEEDBACK:
      return {
        ...state,
        feedback: [action.payload, ...state.feedback],
        userFeedback: [action.payload, ...state.userFeedback],
        loading: false
      };
    case UPDATE_FEEDBACK:
      return {
        ...state,
        feedback: state.feedback.map(item => 
          item._id === action.payload._id ? action.payload : item
        ),
        userFeedback: state.userFeedback.map(item => 
          item._id === action.payload._id ? action.payload : item
        ),
        loading: false
      };
    case DELETE_FEEDBACK:
      return {
        ...state,
        feedback: state.feedback.filter(item => item._id !== action.payload),
        userFeedback: state.userFeedback.filter(item => item._id !== action.payload),
        loading: false
      };
    case ARCHIVE_FEEDBACK:
      return {
        ...state,
        feedback: state.feedback.map(item => 
          item._id === action.payload._id ? action.payload : item
        ),
        userFeedback: state.userFeedback.map(item => 
          item._id === action.payload._id ? action.payload : item
        ),
        loading: false
      };
    case FEEDBACK_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    case SET_LOADING:
      return {
        ...state,
        loading: true
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null
      };
    case CLEAR_FEEDBACK:
      return {
        ...state,
        feedback: [],
        userFeedback: [],
        loading: false
      };
    default:
      return state;
  }
};

export default feedbackReducer;